import { LetterBox } from '../../components/letterboxPage/LetterBox';

export const LetterBoxPage = () => {
  return (
    <div>
      <LetterBox />
    </div>
  );
};
